<template>
  <div class="modal-background">
    <div class="modal-wrapper" :class="{TA:isTestAchat}">
      <div class="modal">
        <h1>{{ title }}
          <span class="close" @click="$emit('close', value)"><SvgIcon icon="close"></SvgIcon></span>
        </h1>
        <h2>{{ subTitle }}</h2>
        <div class="content-centered">
          <SvgIcon :icon="icon" class="icon" fill/>
          <p v-html="text"/>
        </div>
      </div>
      <button class="button main" :class="{TA:isTestAchat}" @click="$emit('close', value)">{{ cancel }}</button>
      <button class="button main" :class="{TA:isTestAchat}" @click="$emit('confirm')">{{ confirm }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    confirm: {
      type: String,
      required: true,
    },
    cancel: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"])
  }
};
</script>
<style lang="scss" scoped>
.modal-wrapper {
  top: 35%;
  margin: 0 20%;
}

.modal h1 {
  font-size: 1.2rem !important;
}

.modal .icon {
  cursor: pointer;
  font-size: 3rem;
  width: 70px;
  height: 70px;
  border-radius: 20%;
  background: white;
  color: #fdcb47;
  box-shadow: 5px 10px 10px #4d545a12;
}

.modal p {
  font-size: 1rem !important;
}

.TA {
  .modal .icon {
    color: $pink!important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue